import styled from "styled-components";

export const SensorTemperatureArticle= styled.article`
  border-radius: 15px;
  outline: 1px solid black;
  display: flex;
  cursor: pointer;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  max-width: 200px;
  width: 100%;
  //height: 190px;

  //&:hover {
  //  background: rgba(246, 238, 229, 0.5);
  //}

  @media (max-width: 760px) {
    &:hover {
      background: transparent;
    }

    cursor: none;
  }
`
export const SensorTemperatureImg= styled.img`
  margin-top: 10px;
  object-fit: cover;
  height: 100%;
  //height: 100%;
  max-height: 70px;
`


type SensorTemperatureDivProps = {
    isExpired?: boolean
}

export const SensorTemperatureDiv= styled.div<SensorTemperatureDivProps>`
  color: ${({isExpired}) => isExpired ? 'red': "black"};;
  margin: 0 0 2px 0;
  text-align: center;
  padding: 0 2px 0 2px;
  display: flex;
  align-items: center;
  img {
    height: 20px;
    margin-right: 5px;
  }
`

export const SensorTemperatureText = styled.p`
  margin: 0 0 2px 0;
  padding: 0 2px 0 2px;

`
